import { useCallback, useState } from 'react';
import { useNotification } from '@refinedev/core';
import { httpClient, ROOT_URL } from '../../App';
import { getErrorMessage } from '../../api/error';
import { IDocumentsChanges, InvoicePayable } from '../components/interface';
import PaymentStatus from '../../types/paymentStatus.type';
import FeesPayer from '../../types/feesPayer.type';

interface IUpdateInvoicePayableData
  extends Pick<InvoicePayable['paymentRequest'], 'specialInstructions' | 'purposeOfRemittance'> {
  serviceProviderId?: number;
  status: PaymentStatus;
  feesPayer?: FeesPayer;
  documentChanges?: IDocumentsChanges;
  reason?: string | null;
}
export const useUpdateInvoicePayable = (id?: number) => {
  const [isLoading, setIsLoading] = useState(false);

  const { open: openNotification } = useNotification();

  const update = useCallback(
    async (data: IUpdateInvoicePayableData) => {
      if (!Number.isInteger(id)) {
        return null;
      }
      const { specialInstructions, serviceProviderId, documentChanges, status, purposeOfRemittance, feesPayer, reason } = data;
      const documentsChanged = !(!documentChanges?.new?.length && !documentChanges?.deleted?.length);
      setIsLoading(true);
      try {
        const updateData = {
          id,
          serviceProviderId,
          documentChanges: documentsChanged ? documentChanges : undefined,
          status,
          purposeOfRemittance,
          specialInstructions,
          feesPayer,
          reason,
        };
        await httpClient.patch(`${ROOT_URL}/api/v1/invoice_payables/update`, updateData);
        setIsLoading(false);
        if (openNotification) {
          openNotification?.({
            key: "success_transaction",
            type: "success",
            message: `Update invoice successfully`,
          });
        }
        return true;
      } catch (error) {
        const message = getErrorMessage(error);
        if (openNotification) {
          openNotification({
            key: 'edit_failure',
            message: `Error editing invoice #${id}`,
            description: message || 'Something went wrong',
            type: 'error',
          });
        }
        setIsLoading(false);
        return false;
      }
    },
    [id, openNotification],
  );

  return { update, isLoading };
};
